// src/features/vendor/components/layout/VendorLayout.jsx
import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Menu, UserCheck } from 'lucide-react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import VendorSidebar from './VendorSidebar';
import '../../vendor.css';

export default function VendorLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
      <div className="admin-layout">
        <VendorSidebar
            isOpen={sidebarOpen}
            onClose={() => setSidebarOpen(false)}
            onLogout={handleLogout}
        />
        <div className="admin-main">
          {/* هدر تکراری حذف شد و فقط دکمه منوی موبایل باقی ماند */}
          <header className="admin-header mobile-only-header">
            <div className="admin-header-left">
              <button onClick={() => setSidebarOpen(true)} className="admin-menu-btn" aria-label="باز کردن منو">
                <Menu size={22} />
              </button>
            </div>
          </header>
          <main className="admin-content">
            <Outlet />
          </main>
        </div>
      </div>
  );
}